export default __webpack_public_path__ + "static/media/fund-identified.503b9b75.png";